import modelMap from "@/models";

// @TODO Pensar uma maneira que evite dependência circular para esta factory
class ModelFactory {
  constructor() {
    this.instantiationStack = new Set();
  }

  /**
   * Instancia uma model pelo nome de seu recurso
   * @param resource
   * @param data
   * @returns {*}
   */
  instantiateByResourceName(resource, data = null, include = []) {
    const dataId = data && data.id ? data.id : 'undefined';
    const stackKey = resource + '-' + dataId;

    if (this.instantiationStack.has(stackKey)) {
      return modelMap[resource]().default;
    }

    this.instantiationStack.add(stackKey);

    let model = modelMap[resource]().default;
    if (data !== null) {
      model = model.deserialize(data, include);
    }

    this.instantiationStack.delete(stackKey);
    return model;
  }
}

export default new ModelFactory();
